import { render } from "./ActivityLogs.vue?vue&type=template&id=5988a8ce&scoped=true"
import script from "./ActivityLogs.vue?vue&type=script&lang=js"
export * from "./ActivityLogs.vue?vue&type=script&lang=js"

import "./ActivityLogs.vue?vue&type=style&index=0&id=5988a8ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5988a8ce"]])

export default __exports__